import React from 'react';
import ObjectEditContainer from '../objecteditcontainer';

const ObjectEditor = React.memo(
	({label='Object Value:', ...props}) => <ObjectEditContainer label={label} {...props}/>
);

export default ObjectEditor;